import axios from 'axios';
import { REQUEST_TIMEOUT } from '../constants/general';
import { generateXB3TraceID, getChannelID, getHost, isSsr, getTmxId, } from '../utils/general';
import { getAuthorizationToken } from '../utils/user';
var baseurl = getHost();
var channelId = getChannelID();
var TMXProfileID = isSsr ? '' : getTmxId();
var baseConfig = {
    baseURL: baseurl,
    headers: {
        TMXProfileID: TMXProfileID,
    },
    timeout: REQUEST_TIMEOUT,
};
var b2cConfig = {
    baseURL: baseurl,
    headers: {
        channelId: channelId,
        TMXProfileID: TMXProfileID,
        Authorization: getAuthorizationToken(),
        'Content-Type': 'application/json',
        Accept: 'application/json',
    },
    timeout: REQUEST_TIMEOUT,
};
var b2bConfig = {
    baseURL: baseurl,
    headers: {
        channelId: channelId,
        TMXProfileID: TMXProfileID,
        'X-B3-TraceId': generateXB3TraceID(),
    },
    timeout: REQUEST_TIMEOUT,
};
var apiBase = axios.create(baseConfig);
var apiB2C = axios.create(b2cConfig);
var apiB2B = axios.create(b2bConfig);
export { apiBase, apiB2C, apiB2B };
